import { render } from "./StorageEdit.vue?vue&type=template&id=eeca7a5a"
import script from "./StorageEdit.vue?vue&type=script&lang=js"
export * from "./StorageEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__